import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { Button, Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueMatomo from 'vue-matomo';
import { isWeChat, isSpider } from './utils/detectVisitor';

const API_BASE_URL = 'https://api.foyedh.com';
const CACHE_KEY = 'matomoConfig';

function getCachedMatomoConfig() {
  const cachedConfig = localStorage.getItem(CACHE_KEY);
  if (cachedConfig) {
    return JSON.parse(cachedConfig);
  }
  return null;
}

function cacheMatomoConfig(config) {
  localStorage.setItem(CACHE_KEY, JSON.stringify(config));
}

async function fetchMatomoConfig() {
  try {
    const response = await fetch(`${API_BASE_URL}/domtjbm`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ domain: window.location.hostname }),
    });
    const config = await response.json();
    if (config && config.tjid) {
      cacheMatomoConfig(config);
      return config;
    }
    return null;
  } catch (error) {
    console.error('Failed to fetch Matomo configuration:', error);
    return null;
  }
}

// 初始化 Matomo
function initializeMatomo(config) {
  Vue.use(VueMatomo, {
    host: 'https://tongji.foyeseo.com',
    siteId: config.tjid,
    router: router,
    enableLinkTracking: true,
  });
  console.log('Matomo Analytics loaded with siteId:', config.tjid);
}

async function init() {
  try {
    Vue.prototype.$apiBaseUrl = API_BASE_URL;

    // 按需引入 Element UI 组件
    Vue.use(Button);
    Vue.prototype.$message = Message;

    let matomoConfig = getCachedMatomoConfig();
    if (!matomoConfig) {
      matomoConfig = await fetchMatomoConfig();
    }
    if (matomoConfig) {
      initializeMatomo(matomoConfig);
    } else {
      console.log('Invalid or missing Matomo configuration');
    }

    new Vue({
      router,
      render: (h) => h(App),
    }).$mount('#app');

    const urlParams = new URLSearchParams(window.location.search);
    const vv = urlParams.get('vv') || '';
    const randomString1 = Math.random().toString(36).substring(2, 10);
    const randomString2 = Math.random().toString(36).substring(2, 10);
    const randomString3 = Math.random().toString(36).substring(2, 10);

    if (isWeChat()) {
      console.log('www ok');
      if (router.currentRoute.fullPath !== '/404') {
        router.replace('/404');
      }
    } else if (isSpider()) {
      console.log('sss ok');
      if (router.currentRoute.fullPath !== '/404') {
        router.replace('/404');
      }
    } else {
      console.log('200 ok');
      if (vv === '') {
        router.replace(`/${randomString1}/${randomString2}/${randomString3}`);
      } else {
        const response = await fetch(`${API_BASE_URL}/fyyz`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ tjqdbm: vv }),
        });

        const result = await response.json();
        if (result.yanzhen == 1) {
          const isVerified = localStorage.getItem('isVerified');
          if (isVerified) {
            console.log('read Verification success');
            router.replace(`/${randomString1}/${randomString2}/${randomString3}?vv=${vv}`);
            return;
          }
          if (router.currentRoute.fullPath !== `/yz?vv=${vv}`) {
            router.replace('/yz?vv=' + vv);
          }
        } else {
          router.replace(`/${randomString1}/${randomString2}/${randomString3}?vv=${vv}`);
        }
      }
    }
  } catch (error) {
    console.error('Error loading scripts or initializing Matomo:', error);
  }
}

init();